var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "picture-placeholder-container",
      style: { background: _vm.backgroundColor },
    },
    [
      _c("div", {
        staticClass: "picture-placeholder-picture",
        style: { backgroundImage: "url(" + _vm.pictureUrl + ")" },
      }),
      _vm._v(" "),
      _vm.showInitials
        ? _c(
            "div",
            {
              staticClass: "picture-placeholder-initials",
              style: { color: _vm.color, fontSize: _vm.fontSize },
            },
            [_vm._v(" " + _vm._s(_vm.textDisplay) + " ")]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }